function dayRank(item) {
  const day = parseInt(item?.date, 10);
  if (!Number.isInteger(day) || day < 0 || day > 31) return null;
  return day;
}

function sequenceRank(item, index) {
  const sequence = Number(item?.sequence);
  return Number.isFinite(sequence) ? sequence : index;
}

function sortCashItems(items, key = 'sequence', dir = 'asc') {
  const indexed = (items || []).map((item, index) => ({ item, index }));
  // Sequence display follows array order. A value such as 17.5 stays put
  // until blur runs sortAndRenumber.
  if (key !== 'day') {
    return dir === 'desc' ? indexed.reverse() : indexed;
  }
  const sign = dir === 'desc' ? -1 : 1;
  return indexed.sort((a, b) => {
    const aDay = dayRank(a.item);
    const bDay = dayRank(b.item);
    if (aDay == null && bDay == null) return a.index - b.index;
    if (aDay == null) return 1;
    if (bDay == null) return -1;
    if (aDay !== bDay) return (aDay - bDay) * sign;
    const aSequence = sequenceRank(a.item, a.index);
    const bSequence = sequenceRank(b.item, b.index);
    if (aSequence !== bSequence) return aSequence - bSequence;
    return a.index - b.index;
  });
}

function nextCashSort(currentKey, currentDir, clickedKey) {
  if (currentKey === clickedKey) {
    return { key: clickedKey, dir: currentDir === 'asc' ? 'desc' : 'asc' };
  }
  return { key: clickedKey, dir: 'asc' };
}

module.exports = {
  sortCashItems,
  nextCashSort,
};
